import React from 'react'
import { Helmet } from 'react-helmet';

export default function StructuredHomepage() {
  // ToDo: make url property a dynamic value, utilzing an env variable to handle different locales
  return (
    <Helmet>
      <script type="application/ld+json">
        {`{
          "@context": "http://schema.org",
          "@type": "LocalBusiness",
          "name": "Thermacell Repellents, Inc.",
          "image": "https://cdn.shopify.com/s/files/1/2537/3762/files/Logo-4x_400x200.png?v=1520461881",
          "url": "https://www.thermacell.com",
          "description": "Thermacell makes effective mosquito repellent and tick control products, including portable mosquito repellers, patio shield and tick control tubes. For use from your backyard to the great outdoors, Thermacell liberates people who love the outdoors from the harmful effects of insects.",
          "telephone": "781-541-6900",
          "priceRange": "$",
          "hasMap": "https://www.google.com/maps/place/Thermacell+Repellents+Inc/@42.5088524,-71.2467459,17z/data=!3m1!4b1!4m5!3m4!1s0x89e39f4208d6e89d:0x7e61c2b90d0d2ac8!8m2!3d42.5088485!4d-71.2445572",
          "sameAs": [
            "https://www.facebook.com/ThermacellOutdoors/",
            "https://www.instagram.com/thermacell/",
            "https://www.youtube.com/user/Thermacell",
            "https://twitter.com/thermacell"
          ],
          "openingHours": [
            "M-F 8:00am - 5:00pm EST"
          ],
          "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "1870"
          },
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "26 Crosby Drive",
            "addressLocality": "Bedford",
            "postalCode": "01730",
            "addressCountry": "US",
            "addressRegion": "MA"
          },
          "location": {
            "@type": "Place",
            "geo": {
              "@type": "GeoCircle",
              "geoRadius": "50",
              "geoMidpoint": {
                "@type": "GeoCoordinates",
                "latitude": "42.5088524",
                "longitude": "-71.2467459"
              }
            }
          }
        }`}
      </script>

      <script type="application/ld+json">
        {`{
          "@context": "http://schema.org",
          "@type": "SiteNavigationElement",
          "url": "https://www.thermacell.com"
        }`}
      </script>
    </Helmet>
  )
}
